/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IValidateAddressWebRequest,
  TValidateAddressWebModel,
  IMappers,
  TValidateAddressWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IHouseIdResponse } from '../../entities/flat_areas/HouseIdResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createValidateAddressWebModel(parameters: IValidateAddressWebRequest): TValidateAddressWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/v1/validate-address-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IValidateAddressWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IValidateAddressWebRequest;
}

export async function fetchValidateAddressWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IValidateAddressWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TValidateAddressWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createValidateAddressWebModel(parameters),
    config,
  )) as FetchResponse<TValidateAddressWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IHouseIdResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TValidateAddressWebResponse>;
}
